import { Resource as e } from "@coveo/platform-client";
import { ChunkInspectorAnswerResource as n } from "./answer/ChunkInspectorAnswer.js";
import { ChunkInspectorDocumentResource as t } from "./document/ChunkInspectorDocument.js";
import { ChunkInspectorSearchResource as c } from "./search/ChunkInspectorSearch.js";
class R extends e {
  constructor(o, r) {
    super(o, r), this.answer = new n(o, r), this.search = new c(o, r), this.document = new t(o, r);
  }
}
export {
  R as ChunkInspectorResource
};
//# sourceMappingURL=ChunkInspectorResource.js.map
